import { deleteUser, deleteUserQuery } from 'actions';
import { removeUsers, selectAllUsers, selectUsers } from 'actions/userPermissionsPage';
import ConfirmModal from 'components/ConfirmModal';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsSelectAll } from 'selectors/userPermissionsPage';
import { getUsersTotalCount } from 'selectors/users';
import type { User } from 'types';

type ComponentProps = {
  users: User[];
  shouldDeleteUser?: boolean;
};

const UsersInformationSection: React.FC<ComponentProps> = ({ users, shouldDeleteUser = false }) => {
  const dispatch = useDispatch();

  const isSelectAll = useSelector(getIsSelectAll);
  const usersCount = useSelector(getUsersTotalCount);

  const [isDeletingUsers, setIsDeletingUsers] = useState(false);

  const toggleConfirmModal = (): void => setIsDeletingUsers(false);

  const clearSelection = (): void => {
    dispatch(selectUsers([]));
    dispatch(selectAllUsers(false));
  };

  const handleDeleteUser = (): void => {
    if (isSelectAll) {
      dispatch(deleteUserQuery());
    } else {
      dispatch(deleteUser({ uuids: users.map((user) => user.uuid) }));
    }
    clearSelection();
    toggleConfirmModal();
  };

  const handleDelete = (): void => {
    if (shouldDeleteUser) {
      setIsDeletingUsers(true);
    } else {
      dispatch(removeUsers([...users]));
      clearSelection();
    }
  };

  const deleteCount = isSelectAll ? usersCount : users.length;

  return (
    <div className="px-3 pt-4 flex flex-row gap-1 w-full">
      <div className="flex flex-row justify-end w-full">
        <button
          type="button"
          className="self-end text-body focus:outline-none"
          onClick={handleDelete}
        >
          <span className="text-litlingo-alert underline">Delete selected users</span>
        </button>
      </div>

      {isDeletingUsers && (
        <ConfirmModal
          text={`Are you sure you want to delete ${deleteCount} users?`}
          okButtonText="Yes"
          cancelButtonText="No"
          okButtonOnClick={handleDeleteUser}
          toggleShowModal={toggleConfirmModal}
        />
      )}
    </div>
  );
};

export default UsersInformationSection;
